function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { EVENT_TYPES } from '../../../lib/analytics/constants';
import Logger from '../../../lib/analytics/logger';
import ERROR_CODE from '../../../utils/errorCodes';
import { toFixedWithoutRounding } from '../../../utils/number';

var formatter = require('format-number');

export var format = formatter({
  prefix: '',
  suffix: '',
  truncate: 0
});
export var getTruncationObject = function getTruncationObject(value) {
  var truncationTypes = [{
    value: 0,
    postfix: ''
  }, {
    value: 1,
    postfix: ''
  }, {
    value: 1000,
    postfix: 'K'
  }, {
    value: 1000000,
    postfix: 'M'
  }, {
    value: 1000000000,
    postfix: 'B'
  }, {
    value: 1000000000000,
    postfix: 'T'
  }];
  var rval = null;
  truncationTypes.forEach(function (truncationType) {
    if (value >= truncationType.value) {
      rval = truncationType;
    }
  });
  return rval;
};
export var truncateValueGenerator = function truncateValueGenerator(initialValue) {
  var _finalValue;

  var formatedValue = format(initialValue);
  var initialValue_truncater = getTruncationObject(initialValue);
  var finalValue = initialValue / initialValue_truncater.value;

  if ((_finalValue = finalValue) === null || _finalValue === void 0 ? void 0 : _finalValue.toString().includes('.')) {
    finalValue = finalValue.toFixed(1);
  }

  formatedValue = finalValue + initialValue_truncater.postfix;
  return formatedValue;
};
export var bonusInfoGenerator = function bonusInfoGenerator(bonusRes, changeSpinnerItems) {
  try {
    var bonusInfo = bonusRes;
    if (bonusInfo === false) return false;
    var spinnerItems = JSON.parse(JSON.stringify(bonusInfo.SPINNER_ITEMS));

    for (var i = 0; i < spinnerItems.length; i++) {
      var truncater = getTruncationObject(spinnerItems[i].AMOUNT);
      var val = spinnerItems[i].AMOUNT / truncater.value;
      val = Math.floor(val * 10) * 0.1;
      spinnerItems[i].AMOUNT = Math.floor(val) + "\u200A" + truncater.postfix;
    }

    var _iterator = _createForOfIteratorHelper(bonusInfo.LOGIN_STREAK_BONUS_LIST),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var login_item = _step.value;
        var coin_truncater = getTruncationObject(login_item.coins);
        var loyalty_truncater = getTruncationObject(login_item.loyalty);
        login_item.coins_trunc = login_item.coins === 0 ? 0 : toFixedWithoutRounding(login_item.coins / coin_truncater.value) + coin_truncater.postfix;
        login_item.loyalty_trunc = login_item.loyalty === 0 ? 0 : login_item.loyalty / loyalty_truncater.value + loyalty_truncater.postfix;
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    changeSpinnerItems(spinnerItems);
    return bonusInfo;
  } catch (e) {
    Logger.sendEvent(EVENT_TYPES.FRONTEND_ERROR, {
      error: JSON.stringify(e, Object.getOwnPropertyNames(e)),
      code: ERROR_CODE.DAILY_SPIN_GET_BONUS_INFO_ERROR
    });
    return false;
  }
};
export var getLoginStreakList = function getLoginStreakList(bonusInfo) {
  var _bonusInfo$LOGIN_STRE;

  var loginStreakList = bonusInfo === null || bonusInfo === void 0 ? void 0 : (_bonusInfo$LOGIN_STRE = bonusInfo.LOGIN_STREAK_BONUS_LIST) === null || _bonusInfo$LOGIN_STRE === void 0 ? void 0 : _bonusInfo$LOGIN_STRE.slice(0);
  var loginStreakFinal = {};
  var loginStreakFinalDayNum = 0;

  if (bonusInfo === null || bonusInfo === void 0 ? void 0 : bonusInfo.WHEEL_HERO) {
    var _loginStreakFinal;

    loginStreakFinal = loginStreakList && loginStreakList[(loginStreakList === null || loginStreakList === void 0 ? void 0 : loginStreakList.length) - 1];
    loginStreakFinalDayNum = (_loginStreakFinal = loginStreakFinal) === null || _loginStreakFinal === void 0 ? void 0 : _loginStreakFinal.day;
    loginStreakList === null || loginStreakList === void 0 ? void 0 : loginStreakList.shift();
  } else {
    var _loginStreakFinal2;

    loginStreakFinal = loginStreakList === null || loginStreakList === void 0 ? void 0 : loginStreakList.pop();
    loginStreakFinalDayNum = (_loginStreakFinal2 = loginStreakFinal) === null || _loginStreakFinal2 === void 0 ? void 0 : _loginStreakFinal2.day;
  }

  return {
    loginStreakList: loginStreakList,
    loginStreakFinal: loginStreakFinal,
    loginStreakFinalDayNum: loginStreakFinalDayNum
  };
};
export var lightAssets = function lightAssets(dailyWheelAssets) {
  return [dailyWheelAssets.DAILY_SPIN_COLUMN_LIGHT_OFF, dailyWheelAssets.DAILY_SPIN_COLUMN_LIGHT_1, dailyWheelAssets.DAILY_SPIN_COLUMN_LIGHT_2, dailyWheelAssets.DAILY_SPIN_COLUMN_LIGHT_3, dailyWheelAssets.DAILY_SPIN_COLUMN_LIGHT_4, dailyWheelAssets.DAILY_SPIN_COLUMN_LIGHT_5, dailyWheelAssets.DAILY_SPIN_COLUMN_LIGHT_6, dailyWheelAssets.DAILY_SPIN_COLUMN_LIGHT_7, dailyWheelAssets.DAILY_SPIN_COLUMN_LIGHT_8, dailyWheelAssets.DAILY_SPIN_COLUMN_LIGHT_9];
};
export var SPINNER_ITEM_REWARD_TYPE = {
  REGULAR: 'regular',
  OUTSTANDING: 'outstanding'
};